export default __webpack_public_path__ + "static/media/season-3.ef66f4e1.png";